import React, { useEffect } from 'react';
import Grid from '@mui/material/Grid';
import { Box, MenuItem, Select, Tab, Tabs } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import DefaultSelectClient from '../../components/default-select-client';
import { ACTION_TYPES, usePublicacaoDiarioOficialDispatch, usePublicacaoDiarioOficialState } from './context/publicacao-diario-oficial-context';
import { usePublicacaoDiarioOficialController } from './context/publicacao-diario-oficial-controller';
import DefaultUploadFiles from '../../components/default-upload-files';
import dayjs, { Dayjs } from 'dayjs';
import { useParams } from 'react-router-dom';


export const PublicacaoDiarioOficialForm = () => {
    const { files, previewPublicationRequest, tabIndexForm, listDocumentTypesResponse, subCategoryPublicationResponse, entityPublicationResponse, categoryPublicationResponse } = usePublicacaoDiarioOficialState();
    const { handleOnChange, handleTabFormChange, setDataPublicationAndUpdate, setFiles, getInit, loadSubcategory } = usePublicacaoDiarioOficialController();
    const publicacaoDiarioOficialDispatch = usePublicacaoDiarioOficialDispatch();
    const { publicationShipmentId } = useParams();

    useEffect(() => {
        getInit();

        if (previewPublicationRequest !== undefined && previewPublicationRequest.categoryId !== 0) {
            loadSubcategory(previewPublicationRequest.categoryId);
        }

        if (publicationShipmentId !== null && publicationShipmentId !== undefined) {
            setDataPublicationAndUpdate(Number(publicationShipmentId));
        }


    }, []);

    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2}>
                    <Grid item lg={8}
                        sm={8}
                        xl={8}>
                        <DefaultSelectClient required={true} clientId={previewPublicationRequest.clientId} disabled={previewPublicationRequest.submissionPublicationId !== undefined ? true : false} handleOnChange={handleOnChange}></DefaultSelectClient>

                    </Grid>
                    <Grid
                        item
                        lg={2}
                        sm={2}
                        xl={2}
                    >
                        <InputLabel>Data da Publicação</InputLabel>
                        <OutlinedInput
                            size="small"
                            value={previewPublicationRequest?.publicationDateOn != null ? dayjs(previewPublicationRequest?.publicationDateOn).format("DD/MM/YYYY") : null}
                            name="input-number"
                            disabled={true}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={2}
                        sm={2}
                        xl={2}
                        sx={{
                            display: "flex", justifyContent: 'flex-end'
                        }}

                    >
                        <FormControlLabel control={<Switch checked={previewPublicationRequest.republication} name="switch-repubblication" onChange={handleOnChange} />} label="Republicação" />

                    </Grid>

                    <Grid item lg={6}
                        sm={6}
                        xl={6}>
                        <InputLabel>Categoria</InputLabel>
                        <Select
                            size="small"
                            onChange={handleOnChange}
                            fullWidth
                            error={previewPublicationRequest.categoryId === undefined ? true : false}
                            name='select-category'
                            value={previewPublicationRequest.categoryId}
                        >
                            <MenuItem value={undefined}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {categoryPublicationResponse?.map((element, index) => {
                                return (
                                    <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                                );
                            })}

                        </Select>
                    </Grid>
                    <Grid item lg={6}
                        sm={6}
                        xl={6}>
                        <InputLabel>Subcategoria</InputLabel>
                        <Select
                            size="small"
                            name='select-subcategory'
                            onChange={handleOnChange}
                            fullWidth
                            error={previewPublicationRequest.subcategoryId === undefined ? true : false}
                            value={previewPublicationRequest.subcategoryId}
                        >
                            <MenuItem value={undefined}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {subCategoryPublicationResponse?.map((element, index) => {
                                return (
                                    <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                                );
                            })}

                        </Select>
                    </Grid>
                    <Grid item lg={6}
                        sm={6}
                        xl={6}>
                        <InputLabel>Orgão de Publicação</InputLabel>
                        <Select
                            name='select-entity-publication'
                            onChange={handleOnChange}
                            fullWidth
                            size="small"
                            error={previewPublicationRequest.publicAgencyId === undefined ? true : false}
                            value={previewPublicationRequest.publicAgencyId}
                        >
                            <MenuItem value={undefined}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {entityPublicationResponse?.map((element) => {
                                return (
                                    <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                                );
                            })}

                        </Select>
                    </Grid>

                    <Grid item lg={6}
                        sm={6}
                        xl={6}>
                        <InputLabel>Tipo de Documento</InputLabel>
                        <Select
                            size="small"
                            name='select-dcoument-type'
                            onChange={handleOnChange}
                            fullWidth
                            error={previewPublicationRequest.documentTypeId === undefined ? true : false}
                            value={previewPublicationRequest.documentTypeId}
                        >
                            <MenuItem value={undefined}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {listDocumentTypesResponse?.map((element) => {
                                return (
                                    <MenuItem value={element.id} key={element.id}>{element.description}</MenuItem>
                                );
                            })}

                        </Select>
                    </Grid>


                    <Grid item xs={1} md={1} lg={1}>
                        <InputLabel>{previewPublicationRequest.categoryId === 2 ? 'Ano Base' : 'Número'}</InputLabel>
                        <OutlinedInput
                            size="small"
                            value={previewPublicationRequest?.number}
                            name="input-number"
                            onChange={handleOnChange}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={4} md={4} lg={4}>
                        <InputLabel>Comissão de Licitação</InputLabel>
                        <OutlinedInput
                            size="small"
                            disabled={previewPublicationRequest.categoryId !== 3 ? true : false}
                            value={previewPublicationRequest?.descriptionCommission}
                            name="input-description-comission"
                            fullWidth
                            onChange={handleOnChange}
                        />
                    </Grid>
                    <Grid item xs={5} md={5} lg={5}>
                        <InputLabel>Responsável da Comissão de Licitação</InputLabel>
                        <OutlinedInput
                            size="small"
                            disabled={previewPublicationRequest.categoryId !== 3 ? true : false}
                            value={previewPublicationRequest?.descriptionPresidentCommission}
                            name="input-description-president-comission"
                            fullWidth
                            onChange={handleOnChange}
                        />
                    </Grid>

                    <Grid
                        item
                        lg={2}
                        sm={2}
                        xl={2}
                    >
                        <InputLabel>{previewPublicationRequest.categoryId !== 3 ? 'Data de Sanção' : 'Data de Abertura'}</InputLabel>
                        <DesktopDatePicker

                            disabled={previewPublicationRequest.categoryId !== 3 ? true : false}
                            format='DD/MM/YYYY'
                            slotProps={{ textField: { fullWidth: true, size: "small" } }}

                            value={previewPublicationRequest?.sanctionDateOn != null ? dayjs(previewPublicationRequest?.sanctionDateOn) : null}
                            onChange={(value: Dayjs | null) => {
                                let sanctionDateOn = value?.format("YYYY-MM-DD");
                                publicacaoDiarioOficialDispatch({
                                    type: ACTION_TYPES.setPreviewPublicationRequest,
                                    payload: { ...previewPublicationRequest, sanctionDateOn },
                                });
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                        <Box>
                            <Box>
                                <Tabs value={tabIndexForm} onChange={handleTabFormChange}>
                                    <Tab label="Descrição" />
                                    <Tab label="Observação" />
                                </Tabs>
                            </Box>
                        </Box>
                        <Box sx={{ pt: 2 }}>
                            {tabIndexForm === 0 && (
                                <Box>
                                    <OutlinedInput
                                        size="small"
                                        error={previewPublicationRequest.description === undefined || previewPublicationRequest.description.length === 0 ? true : false}
                                        multiline
                                        rows={5}
                                        inputProps={{ maxLength: 5000, textTransform: "uppercase" }}
                                        onChange={handleOnChange}
                                        name="input-description"
                                        value={previewPublicationRequest?.description}
                                        fullWidth
                                    />

                                </Box>
                            )}
                            {tabIndexForm === 1 && (
                                <Box>
                                    <OutlinedInput
                                        size="small"
                                        multiline
                                        inputProps={{ maxLength: 5000, textTransform: "uppercase" }}
                                        rows={5}
                                        onChange={handleOnChange}
                                        name="input-notes"
                                        value={previewPublicationRequest?.notes}
                                        fullWidth
                                    />

                                </Box>
                            )}
                        </Box>
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <DefaultUploadFiles
                            setFilesUpload={setFiles}
                            files={files}
                            extensions={["pdf"]}
                            maxFileSizeMb={10}
                        />
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </React.Fragment>)
}